// Remembers, for this tab, that the user signed out, so a protected page reached afterwards (the
// browser's Back button, or a reload of it) goes straight to /signin instead of waiting out
// ProtectedRoute's grace period, which exists only for a session that is still being set up.
// sessionStorage, so it survives a reload of the tab but not a new tab; cleared on the next sign-in.
const KEY = 'jh_session_ended';

export const markSignedOut = () => {
  try { sessionStorage.setItem(KEY, '1'); } catch { /* storage blocked: the in-memory flag still covers this tab */ }
};

export const clearSignedOut = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing to clear */ }
};

export const wasSignedOut = () => {
  try { return sessionStorage.getItem(KEY) === '1'; } catch { return false; }
};
